module.exports = __webpack_public_path__ + "static/img/5.eceaf3d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/6/zh/5.png
// module id = lWqR
// module chunks = 0